function getPluralFormByLanguage(language: string, count: number): string {
    if (language === 'ar' && (count < 3 || count > 10)) return 'singular';
    if (language === 'ar' && count > 2 && count < 11) return 'plural';
    if (count !== 1) return 'plural';
    if (count === 1) return 'singular';
}

export function applyPluralization(language: string, number: number, singularForm: string, pluralForm: string): string {
    const form = getPluralFormByLanguage(language, number);
    return form === 'singular' ? singularForm : pluralForm;
}
